import React, { useRef } from 'react';
import { holdScrollPosition } from '../utils/holdScrollPosition';
import './ViewToggle.css';

/**
 * Bascule d'affichage à 2 segments : liste ↔ groupé (par phase).
 * Contrôle segmenté avec icônes SVG centrées (remplace l'ancien bouton unique).
 *
 * @param {boolean}  grouped     true = vue groupée active, false = vue liste
 * @param {function} onChange    reçoit le nouvel état booléen "grouped"
 * @param {string}   [listLabel]  title/aria du segment liste
 * @param {string}   [groupLabel] title/aria du segment groupé
 */
const ViewToggle = ({
  grouped,
  onChange,
  listLabel = 'Afficher en liste',
  groupLabel = 'Grouper par phase',
}) => {
  const rootRef = useRef(null);

  // La vue groupée est bien plus haute que la liste : sans maintien, quitter l'une pour
  // l'autre en bas de page faisait sauter la page sous le doigt (cf. holdScrollPosition).
  const select = (next) => {
    if (next === grouped) return;
    holdScrollPosition(rootRef.current);
    onChange(next);
  };

  return (
    <div ref={rootRef} className="view-toggle" role="group" aria-label="Type d'affichage">
      <button
        type="button"
        className={`view-toggle__btn${!grouped ? ' view-toggle__btn--on' : ''}`}
        onClick={() => select(false)}
        aria-pressed={!grouped}
        title={listLabel}
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <line x1="3" y1="4" x2="13" y2="4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          <line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          <line x1="3" y1="12" x2="13" y2="12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
      <button
        type="button"
        className={`view-toggle__btn${grouped ? ' view-toggle__btn--on' : ''}`}
        onClick={() => select(true)}
        aria-pressed={grouped}
        title={groupLabel}
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <rect x="2.5" y="2.5" width="4.5" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
          <rect x="9" y="2.5" width="4.5" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
          <rect x="2.5" y="9" width="4.5" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
          <rect x="9" y="9" width="4.5" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;
